// @flow
import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { ReactSelect } from 'styles/Select';
import CountryLocalStore from 'stores/CountryLocalStore';
import CountryLocalActions from 'actions/CountryLocalActions';
import { Field } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'styles/css/Home.css';
const StyledPhoneInput = styled.div`
  display: block;
`;

const StyledPhoneCode = styled.span`
  display: inline-block;
  width: 25%;
  height: 35px;
  border-color: #ececec;
  background-color: #ececec;
  color: #555555;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  line-height: 35px;
  user-select: none;
  text-align: center;
  border: 1px solid #ececec;
  &.active {
    border-color: #278c7e;
    background-color: #278c7e;
    border: 1px solid #278c7e;
    color: white;
  }
`;

const StyledInput = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
  margin-bottom: 20px;
`;

const StyledPhoneNumber = styled(StyledInput)`
  display: inline-block;
  width: 75%;
  position: relative;
  bottom: 1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-bottom: 0;
  &.has-error {
    margin-bottom: 0;
  }
  &::-webkit-input-placeholder,
  &::placeholder {
    font-size: ${props => props.placeholderfontsize}px;
  }
`;

type PropsType = {
  placeHolder?: string,
  placeHolderFontSize?: number,
  handleCountryCodeClick: () => void,
  handleCountryCodePicked: (element: any) => void,
  pickingCountryCode: boolean,
  countryCode: number,
  errors: any,
  touched: any,
  name: string,
  phoneLength: number,
  regExPhoneNumber: string
};

type StateType = {
  countryCodes: [],
  phoneNumber: string
};
export default class PhoneCode extends React.Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props);
    this.state = {
      countryCodes: [],
      phoneNumber: ''
    };
    this.handleCountryCode = this.handleCountryCode.bind(this);
    this.handleCodePicked = this.handleCodePicked.bind(this);
    this.handlePhonePattern = this.handlePhonePattern.bind(this);
  }

  componentDidMount() {
    CountryLocalActions.getPhoneCountryCodes();
  }

  componentWillMount() {
    CountryLocalStore.addChangeListener(this._handleStoreChange);
  }

  componentWillUnmount() {
    CountryLocalStore.removeChangeListener(this._handleStoreChange);
  }

  _handleStoreChange = () => {
    this.setState(
      {
        countryCodes: CountryLocalStore.getCodes()
      },
      () => {
        CountryLocalStore.removeChangeListener(this._handleStoreChange);
      }
    );
  };

  handleCountryCode = (): void => {
    this.props.handleCountryCodeClick();
  };

  handleCodePicked = (element: any): void => {
    this.props.handleCountryCodePicked(element);
  };

  handlePhonePattern = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const regexp = /^[0-9\b]+$/;
    const currentValue = e.target.value;
    if (currentValue == '' || regexp.test(currentValue)) {
      this.setState({
        phoneNumber: currentValue
      });
    }
  };

  render() {
    const {
      pickingCountryCode,
      countryCode,
      errors,
      touched,
      placeHolder = 'Número de celular',
      name = 'phone',
      placeHolderFontSize = 14,
      phoneLength = 10,
      regExPhoneNumber = '[0-9]{10}'
    } = this.props;

    const defaultCountryCode = CountryLocalStore.getCodeByValue(
      `${countryCode}`
    );

    return (
      <StyledPhoneInput>
        <StyledPhoneCode
          onClick={this.handleCountryCode}
          className={pickingCountryCode && 'active'}
        >
          +{countryCode}
          {!pickingCountryCode && (
            <FontAwesomeIcon
              className={'icon-arrow-down'}
              icon={'chevron-down'}
            />
          )}
        </StyledPhoneCode>
        <StyledPhoneNumber
          type="tel"
          name={name}
          maxLength={phoneLength}
          placeholder={placeHolder}
          placeholderfontsize={placeHolderFontSize}
          className={errors && touched ? 'has-error' : ''}
          pattern={regExPhoneNumber}
          onInput={this.handlePhonePattern}
          value={this.state.phoneNumber}
        />
        {pickingCountryCode && (
          <Select
            autoFocus
            placeholder="Busca tu país"
            noOptionsMessage={() => 'Sin resultados'}
            defaultValue={defaultCountryCode}
            value={[]}
            styles={ReactSelect}
            onChange={this.handleCodePicked}
            options={this.state.countryCodes}
          />
        )}
      </StyledPhoneInput>
    );
  }
}
